"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfPaginatedResponseOfFacilityOrientationListItemDto = instanceOfPaginatedResponseOfFacilityOrientationListItemDto;
exports.PaginatedResponseOfFacilityOrientationListItemDtoFromJSON = PaginatedResponseOfFacilityOrientationListItemDtoFromJSON;
exports.PaginatedResponseOfFacilityOrientationListItemDtoFromJSONTyped = PaginatedResponseOfFacilityOrientationListItemDtoFromJSONTyped;
exports.PaginatedResponseOfFacilityOrientationListItemDtoToJSON = PaginatedResponseOfFacilityOrientationListItemDtoToJSON;
exports.PaginatedResponseOfFacilityOrientationListItemDtoToJSONTyped = PaginatedResponseOfFacilityOrientationListItemDtoToJSONTyped;
const FacilityOrientationListItemDto_1 = require("./FacilityOrientationListItemDto");
const PaginationMetaDto_1 = require("./PaginationMetaDto");
/**
 * Check if a given object implements the PaginatedResponseOfFacilityOrientationListItemDto interface.
 */
function instanceOfPaginatedResponseOfFacilityOrientationListItemDto(value) {
    if (!('result' in value) || value['result'] === undefined)
        return false;
    if (!('meta' in value) || value['meta'] === undefined)
        return false;
    return true;
}
function PaginatedResponseOfFacilityOrientationListItemDtoFromJSON(json) {
    return PaginatedResponseOfFacilityOrientationListItemDtoFromJSONTyped(json, false);
}
function PaginatedResponseOfFacilityOrientationListItemDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'result': (json['result'].map(FacilityOrientationListItemDto_1.FacilityOrientationListItemDtoFromJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoFromJSON)(json['meta']),
    };
}
function PaginatedResponseOfFacilityOrientationListItemDtoToJSON(json) {
    return PaginatedResponseOfFacilityOrientationListItemDtoToJSONTyped(json, false);
}
function PaginatedResponseOfFacilityOrientationListItemDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'result': (value['result'].map(FacilityOrientationListItemDto_1.FacilityOrientationListItemDtoToJSON)),
        'meta': (0, PaginationMetaDto_1.PaginationMetaDtoToJSON)(value['meta']),
    };
}
//# sourceMappingURL=PaginatedResponseOfFacilityOrientationListItemDto.js.map